// An opt-in API policy; the server remains authoritative for normalization.
export const getCustomOrderNumberState = (config, values = {}) => {
	const settings = config?.customOrderNumber;
	if (!settings) return null;
	const policies = values[settings.policiesParam];
	const templateId = values[settings.templateParam];
	const policy =
		policies && Object.prototype.hasOwnProperty.call(policies, templateId)
			? policies[templateId]
			: undefined;
	const service = Array.isArray(policy?.services)
		? policy.services.find(
				item =>
					item?.id != null &&
					String(item.id) === String(values[settings.serviceParam]),
			)
		: undefined;
	return {
		visible: !!policy,
		prefix: typeof service?.prefix === 'string' ? service.prefix : undefined,
	};
};
